export default __webpack_public_path__ + "static/media/options.71f82f22.svg";